import InventoryActionType from '../actionTypes/InventoryActionType';

const initialState = { listProduct: [] };

export default (state = initialState, action) => {
  switch (action.type) {
    case InventoryActionType.UPDATE_CHECK:
      return { ...state, updatedCheck: action.updatedCheck };
    case InventoryActionType.DELETE_CHECK:
      return { ...state, deletedCheck: action.deletedCheck };
    default:
      return state;
  }
};
